// ----------------------------------------------------------------------

import { getSlugByPathname } from 'utils/helper';

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  fileManager: path(ROOTS_DASHBOARD, '/files-manager'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    file: path(ROOTS_DASHBOARD, '/file'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },

  //-----------------------------------------------------------------------------------------
  configuration: {
    dynamicForm: path(ROOTS_DASHBOARD, '/configuration/dynamic-form'),
  },
  //-----------------------------------------------------------------------------------------

  staffManagement: {
    slug: 'staff-management',
    root: path(ROOTS_DASHBOARD, '/staff-management'),
    new: path(ROOTS_DASHBOARD, '/staff-management/new'),
    list: path(ROOTS_DASHBOARD, '/staff-management/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/staff-management/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/staff-management/${id}/view`),
  },

  projectManagement: {
    slug: 'project-management',
    root: path(ROOTS_DASHBOARD, '/project-management'),
    new: path(ROOTS_DASHBOARD, '/project-management/new'),
    list: path(ROOTS_DASHBOARD, '/project-management/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/project-management/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/project-management/${id}/view`),
  },

  productManagement: {
    slug: 'product-management',
    root: path(ROOTS_DASHBOARD, '/product-management'),
    new: path(ROOTS_DASHBOARD, '/product-management/new'),
    list: path(ROOTS_DASHBOARD, '/product-management/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/product-management/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/product-management/${id}/view`),
  },
  doctorManagement: {
    slug: 'doctor-management',
    root: path(ROOTS_DASHBOARD, '/doctor-management'),
    new: path(ROOTS_DASHBOARD, '/doctor-management/new'),
    list: path(ROOTS_DASHBOARD, '/doctor-management/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/doctor-management/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/doctor-management/${id}/view`),
  },
  jobListing: {
    slug: 'job-listing',
    root: path(ROOTS_DASHBOARD, '/job-listing'),
    new: path(ROOTS_DASHBOARD, '/job-listing/new'),
    list: path(ROOTS_DASHBOARD, '/job-listing/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/job-listing/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/job-listing/${id}/view`),
  },
  qrCodeManager: {
    slug: 'qr-code-manager',
    root: path(ROOTS_DASHBOARD, '/qr-code-manager'),
    new: path(ROOTS_DASHBOARD, '/qr-code-manager/new'),
    list: path(ROOTS_DASHBOARD, '/qr-code-manager/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/qr-code-manager/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/qr-code-manager/${id}/view`),
  },

  banner: {
    slug: 'banner',
    root: path(ROOTS_DASHBOARD, '/banner'),
    new: path(ROOTS_DASHBOARD, '/banner/new'),
    list: path(ROOTS_DASHBOARD, '/banner/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/banner/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/banner/${id}/view`),
  },
  gallery: {
    slug: 'gallery',
    root: path(ROOTS_DASHBOARD, '/gallery'),
    new: path(ROOTS_DASHBOARD, '/gallery/new'),
    list: path(ROOTS_DASHBOARD, '/gallery/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/gallery/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/gallery/${id}/view`),
  },
  testimonial: {
    slug: 'testimonial',
    root: path(ROOTS_DASHBOARD, '/testimonial'),
    new: path(ROOTS_DASHBOARD, '/testimonial/new'),
    list: path(ROOTS_DASHBOARD, '/testimonial/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/testimonial/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/testimonial/${id}/view`),
  },
  association: {
    slug: 'association',
    root: path(ROOTS_DASHBOARD, '/association'),
    new: path(ROOTS_DASHBOARD, '/association/new'),
    list: path(ROOTS_DASHBOARD, '/association/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/association/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/association/${id}/view`),
  },
  post: {
    slug: 'post',
    root: path(ROOTS_DASHBOARD, '/post'),
    new: path(ROOTS_DASHBOARD, '/post/new'),
    list: path(ROOTS_DASHBOARD, '/post/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/post/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/post/${id}/view`),
  },
  companyManagement: {
    slug: 'company-management',
    root: path(ROOTS_DASHBOARD, '/company-management'),
    new: path(ROOTS_DASHBOARD, '/company-management/new'),
    list: path(ROOTS_DASHBOARD, '/company-management/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/company-management/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/company-management/${id}/view`),
  },
  qualificationLevel: {
    slug: 'qualification-level',
    root: path(ROOTS_DASHBOARD, '/qualification-level'),
    new: path(ROOTS_DASHBOARD, '/qualification-level/new'),
    list: path(ROOTS_DASHBOARD, '/qualification-level/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/qualification-level/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/qualification-level/${id}/view`),
  },
  projectType: {
    slug: 'project-type',
    root: path(ROOTS_DASHBOARD, '/project-type'),
    new: path(ROOTS_DASHBOARD, '/project-type/new'),
    list: path(ROOTS_DASHBOARD, '/project-type/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/project-type/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/project-type/${id}/view`),
  },
  country: {
    slug: 'country',
    root: path(ROOTS_DASHBOARD, '/country'),
    new: path(ROOTS_DASHBOARD, '/country/new'),
    list: path(ROOTS_DASHBOARD, '/country/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/country/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/country/${id}/view`),
  },
  state: {
    slug: 'state',
    root: path(ROOTS_DASHBOARD, '/state'),
    new: path(ROOTS_DASHBOARD, '/state/new'),
    list: path(ROOTS_DASHBOARD, '/state/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/state/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/state/${id}/view`),
  },
  city: {
    slug: 'city',
    root: path(ROOTS_DASHBOARD, '/city'),
    new: path(ROOTS_DASHBOARD, '/city/new'),
    list: path(ROOTS_DASHBOARD, '/city/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/city/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/city/${id}/view`),
  },
  industry: {
    slug: 'industry',
    root: path(ROOTS_DASHBOARD, '/industry'),
    new: path(ROOTS_DASHBOARD, '/industry/new'),
    list: path(ROOTS_DASHBOARD, '/industry/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/industry/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/industry/${id}/view`),
  },
  category: {
    slug: 'category',
    root: path(ROOTS_DASHBOARD, '/category'),
    new: path(ROOTS_DASHBOARD, '/category/new'),
    list: path(ROOTS_DASHBOARD, '/category/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/category/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/category/${id}/view`),
  },
  specialization: {
    slug: 'specialization',
    root: path(ROOTS_DASHBOARD, '/specialization'),
    new: path(ROOTS_DASHBOARD, '/specialization/new'),
    list: path(ROOTS_DASHBOARD, '/specialization/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/specialization/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/specialization/${id}/view`),
  },
  location: {
    slug: 'location',
    root: path(ROOTS_DASHBOARD, '/location'),
    new: path(ROOTS_DASHBOARD, '/location/new'),
    list: path(ROOTS_DASHBOARD, '/location/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/location/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/location/${id}/view`),
  },
  subCategory: {
    slug: 'sub-category',
    root: path(ROOTS_DASHBOARD, '/sub-category'),
    new: path(ROOTS_DASHBOARD, '/sub-category/new'),
    list: path(ROOTS_DASHBOARD, '/sub-category/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/sub-category/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/sub-category/${id}/view`),
  },
  superSubCategory: {
    slug: 'super-sub-category',
    root: path(ROOTS_DASHBOARD, '/super-sub-category'),
    new: path(ROOTS_DASHBOARD, '/super-sub-category/new'),
    list: path(ROOTS_DASHBOARD, '/super-sub-category/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/super-sub-category/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/super-sub-category/${id}/view`),
  },
  featureType: {
    slug: 'feature-type',
    root: path(ROOTS_DASHBOARD, '/feature-type'),
    list: path(ROOTS_DASHBOARD, '/feature-type/list'),
  },
  brands: {
    slug: 'brands',
    root: path(ROOTS_DASHBOARD, '/brands'),
    new: path(ROOTS_DASHBOARD, '/brands/new'),
    list: path(ROOTS_DASHBOARD, '/brands/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/brands/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/brands/${id}/view`),
  },
  jobApplication: {
    slug: 'job-application',
    root: path(ROOTS_DASHBOARD, '/job-application'),
    list: path(ROOTS_DASHBOARD, '/job-application/list'),
    view: (id) => path(ROOTS_DASHBOARD, `/job-application/${id}/view`),
  },
  contactEnquiry: {
    slug: 'contact-enquiry',
    root: path(ROOTS_DASHBOARD, '/contact-enquiry'),
    list: path(ROOTS_DASHBOARD, '/contact-enquiry/list'),
    view: (id) => path(ROOTS_DASHBOARD, `/contact-enquiry/${id}/view`),
  },
  appointmentEnquiry: {
    slug: 'appointment-enquiry',
    root: path(ROOTS_DASHBOARD, '/appointment-enquiry'),
    new: path(ROOTS_DASHBOARD, '/appointment-enquiry/new'),
    list: path(ROOTS_DASHBOARD, '/appointment-enquiry/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/appointment-enquiry/${id}/edit`),
    view: (id) => path(ROOTS_DASHBOARD, `/appointment-enquiry/${id}/view`),
  },
  careerEnquiry: {
    slug: 'career-enquiry',
    root: path(ROOTS_DASHBOARD, '/career-enquiry'),
    list: path(ROOTS_DASHBOARD, '/career-enquiry/list'),
    view: (id) => path(ROOTS_DASHBOARD, `/career-enquiry/${id}/view`),
  },
  dealershipEnquiry: {
    slug: 'dealership-enquiry',
    root: path(ROOTS_DASHBOARD, '/dealership-enquiry'),
    list: path(ROOTS_DASHBOARD, '/dealership-enquiry/list'),
    view: (id) => path(ROOTS_DASHBOARD, `/dealership-enquiry/${id}/view`),
  },
  serviceEnquiry: {
    slug: 'service-enquiry',
    root: path(ROOTS_DASHBOARD, '/service-enquiry'),
    list: path(ROOTS_DASHBOARD, '/service-enquiry/list'),
    view: (id) => path(ROOTS_DASHBOARD, `/service-enquiry/${id}/view`),
  },
  quotationEnquiry: {
    slug: 'quotation-enquiry',
    root: path(ROOTS_DASHBOARD, '/quotation-enquiry'),
    list: path(ROOTS_DASHBOARD, '/quotation-enquiry/list'),
    view: (id) => path(ROOTS_DASHBOARD, `/quotation-enquiry/${id}/view`),
  },
  productEnquiry: {
    slug: 'product-enquiry',
    root: path(ROOTS_DASHBOARD, '/product-enquiry'),
    list: path(ROOTS_DASHBOARD, '/product-enquiry/list'),
    view: (id) => path(ROOTS_DASHBOARD, `/product-enquiry/${id}/view`),
  },
  feedback: {
    slug: 'feedback',
    root: path(ROOTS_DASHBOARD, '/feedback'),
    list: path(ROOTS_DASHBOARD, '/feedback/list'),
    view: ({ enquiryId, documentId }) =>
      path(ROOTS_DASHBOARD, `/feedback/${enquiryId}/view/${documentId}`),
  },
  //-------------------------------------------------------------------------------------------
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};

export const PATH_ZONE_ON_STORE = 'https://mui.com/store/items/zone-landing-page/';

export const PATH_MINIMAL_ON_STORE = 'https://mui.com/store/items/minimal-dashboard/';

export const PATH_FREE_VERSION = 'https://mui.com/store/items/minimal-dashboard-free/';

export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1';

export const MODULE_PATHS = {
  list: 'list',
  new: 'new',
  edit: 'edit',
  view: 'view',
};

export const getDynamicPaths = ({ pathname = '', slugName = '' }) => {
  const slug = slugName || getSlugByPathname(pathname);
  return {
    slug,
    root: path(ROOTS_DASHBOARD, `/${slug}`),
    new: path(ROOTS_DASHBOARD, `/${slug}/${MODULE_PATHS.new}`),
    list: path(ROOTS_DASHBOARD, `/${slug}/${MODULE_PATHS.list}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/${slug}/${id}/${MODULE_PATHS.edit}`),
    view: (id) => path(ROOTS_DASHBOARD, `/${slug}/${id}/${MODULE_PATHS.view}`),
  };
};
